module.exports = __webpack_public_path__ + "static/media/login-link-sent.54f9d600.png";